const __WEBPACK_NAMESPACE_OBJECT__ = AppCore.default.ReactDOM;